import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useIntl } from "react-intl";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "primereact/button";
import { TabMenu } from "primereact/tabmenu";
import * as RoleHelper from "../../../../helpers/RoleHelper";
import { AccessScopeConstants } from "../../../../constants";
import { enterpriseDetailsRequest } from "../../../../store/slices/enterpriseSlice";
import Form from "../../../common/form";
import EnterpriseDetailsForm from "./EnterpriseDetailsForm";
import * as DisplayHepler from "../../../../helpers/DisplayHelper";
import CustomBreadCrumbs from "../../../common/breadcrumbs";

const EnterpriseDetails = ({
  record,
  labels,
  parent,
  user,
  enterpriseDetailsRequest,
  requesting,
  action,
}) => {
  const intl = useIntl();
  const params = useParams();
  const navigate = useNavigate();
  const [isEditable, setIsEditable] = useState(false);
  const [activeTab, setActiveTab] = useState(0);

  const { role } = user || {};
  const canUpdate = RoleHelper.checkRoleScope(
    role?.scope,
    AccessScopeConstants.TenantAccess,
    AccessScopeConstants.UpdateScope
  );

  useEffect(() => {
    enterpriseDetailsRequest({ id: params.id });
  }, [enterpriseDetailsRequest, params.id]);

  return (
    <div>
      <CustomBreadCrumbs
        labels={labels}
        navigate={navigate}
        editLabel={record?.name}
      />
      <div className="edexlms-page-content">
        <div className="edexlms-page-header">
          <div className="edexlms-page-title">
            <span
              className="pi pi-arrow-left mr-2 cursor-pointer"
              onClick={(e) => navigate(parent.to)}
            ></span>
            {intl.formatMessage({ id: "enterprise_details" })}
          </div>
          {(!isEditable && activeTab === 0 && (
            <div className="edexlms-page-actions">
              <Button
                icon="pi pi-pencil"
                outlined
                onClick={() => setIsEditable(!isEditable)}
                label={intl.formatMessage({ id: "edit" })}
                type="button"
                size="small"
                disabled={!canUpdate}
                tooltipOptions={{ showOnDisabled: true, position: "bottom" }}
                tooltip={
                  canUpdate ? "" : intl.formatMessage({ id: "no_permission" })
                }
              />
            </div>
          )) ||
            null}
        </div>
        <div className="edexlms-page-body">
          <TabMenu
            model={[
              {
                label: intl.formatMessage({ id: "basic_info" }),
                command: () => {
                  if (activeTab !== 0) {
                    setActiveTab(0);
                    setIsEditable(false);
                  }
                },
              },
              {
                label: intl.formatMessage({ id: "enterprise_license" }),
                command: (e) => {
                  if (activeTab !== 1) {
                    setActiveTab(1);
                    setIsEditable(false);
                  }
                },
              },
            ]}
          />
          <div className="edexlms-page-body-content enterprise-view-details">
            {(activeTab === 0 && (
              <Form
                initialValues={{
                  ...record,
                  entitlements: [
                    {
                      type: 1,
                      value: record?.entitlements?.[0]?.value,
                    },
                    {
                      type: 2,
                      value:
                        DisplayHepler.convertSize(
                          parseInt(record?.entitlements?.[1]?.value || 0),
                          "B",
                          "GB"
                        ) + "",
                    },
                  ],
                }}
                disabled={!isEditable}
                submitBtn={{
                  label: intl.formatMessage({
                    id: "update_enterprise",
                  }),
                  onClick: () => console.log("submit"),
                  disabled: requesting && action === "update",
                }}
                cancelBtn={{
                  label: intl.formatMessage({
                    id: "cancel",
                  }),
                  onClick: (e) => setIsEditable(false),
                  disabled: requesting && action === "update",
                }}
              >
                <EnterpriseDetailsForm disabled={!isEditable} record={record} />
              </Form>
            )) ||
              null}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  record: state?.enterprises?.record,
  user: state?.self?.user,
  action: state?.enterprises?.action,
  requesting: state?.enterprises?.requesting,
  error: state?.enterprises?.error,
});

const mapDispatchToProps = (dispatch) => ({
  enterpriseDetailsRequest: (data) => dispatch(enterpriseDetailsRequest(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EnterpriseDetails);
